import React from "react";

export const SectionEmbudo = ({ fases, datos }) => {
  const fasesConTotales = fases.map((fase) => {
    const total = datos
      .filter((d) => d.fase === fase)
      .reduce((acc, curr) => acc + curr.cantidad, 0);
    return { fase, total };
  });

  const totalGeneral = fasesConTotales.reduce((acc, f) => acc + f.total, 0);

  const start = { r: 70, g: 147, b: 47 }; //70, 147, 47
  const end = { r: 44, g: 106, b: 38 }; //44, 106, 38

  const interpolateColor = (i, max) => {
    const t = i / (max - 1); // porcentaje del gradiente

    const r = Math.round(start.r + (end.r - start.r) * t);
    const g = Math.round(start.g + (end.g - start.g) * t);
    const b = Math.round(start.b + (end.b - start.b) * t);

    return `rgb(${r}, ${g}, ${b})`;
  };

  return (
    <div class="funnel">
      {fasesConTotales.map((f, index) => {
        const color = interpolateColor(index, fasesConTotales.length);
        const porcentaje = totalGeneral > 0 ? ((f.total / totalGeneral) * 100).toFixed(1) : 0;

        return (
          <div key={f.fase} className="level">
            <div class="mini-ellipse"></div>
            <div
              key={f.fase}
              className="shape p"
            >
              <div style={{ marginTop: "6px" }}>
                {f.fase} ({f.total})
              </div>
            </div>
            {/* <div class="bottom-mini-ellipse be"></div> */}
            <div className="label l">
              {porcentaje}%
            </div>
          </div>
          // <div key={f.fase} className="funnel-row">
          //   <div
          //     key={f.fase}
          //     className="funnel-stage"
          //     style={{
          //       backgroundColor: color
          //     }}
          //   >
          //     <span className="funnel-label">
          //       {f.fase} ({f.total})
          //     </span>
          //   </div>
          //   <div className="funnel-percent">
          //     {porcentaje}%
          //   </div>
          // </div>
        );
      })}
    </div>
  );
};
